import styled from 'styled-components';

import FlexWrap from '@/components/common/FlexWrap';
import FaqButton from '@/components/common/FaqButton';
import Icon from '@/components/common/Icon';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constant/routes.const';
import Typography from '@/components/common/Typography';
import { IGlobalState } from '@/store';
import { ICON_CS } from '@repo/assets';

function TopSection() {
  const { passportNumber, register } = useAppSelector(
    (state) => state,
  ) as IGlobalState;

  return (
    <Container dir='column' justifyContent='center'>
      <FlexWrap
        justifyContent='space-between'
        alignItems='flex-start'
        margin='30px 0 0 0'
      >
        <Typography size='21px' fontWeight='500' color='#1856cd'>
          {!register
            ? `${passportNumber}!\nPlease enter your information.`
            : passportNumber}
        </Typography>
      </FlexWrap>
    </Container>
  );
}

const Container = styled(FlexWrap)`
  width: 100%;
  margin-bottom: 20px;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;

export default TopSection;
